import React, { Component } from 'react';
class OkkjiSelect extends Component {

  render() { 
    return ( 
      <div className='content'>
        <span>OkkjiSelect</span>
      </div>
     );
  }
}
 
export default OkkjiSelect;